const payoutRefundReason = {
  bankError: 'bank_error',
  fraud: 'fraud',
  receiverRequest: 'receiver_request',
  specificService: 'specific_service',
  reverted: 'reverted'
};

module.exports = payoutRefundReason;
